// ---------------------------------------------------------------------
// Cookie consent (RGPD / LSSI-CE). Runs before DOMContentLoaded's other
// listeners so that consent state is known as early as possible. Nothing
// non-essential (analytics, marketing pixels) should load until the
// visitor has explicitly said yes — use window.vaupetConsent.isAllowed()
// or listen for the "vaupet:consent" event before injecting any such
// script (see the helper vaupetConsent.loadScript below).
// ---------------------------------------------------------------------
(function () {
  var STORAGE_KEY = "vaupet_cookie_consent";

  function readConsent() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeConsent(value) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch (e) {
      /* private mode / storage blocked: consent still applies for this visit */
    }
    document.dispatchEvent(new CustomEvent("vaupet:consent", { detail: value }));
  }

  window.vaupetConsent = {
    get: readConsent,
    isAllowed: function (category) {
      var c = readConsent();
      return !!(c && c[category]);
    },
    // Convenience for later: only injects the script once the visitor has
    // consented to that category (immediately if already consented, or
    // as soon as they do via the banner).
    loadScript: function (category, src, attrs) {
      function inject() {
        var s = document.createElement("script");
        s.src = src;
        s.async = true;
        if (attrs) {
          Object.keys(attrs).forEach(function (k) {
            s.setAttribute(k, attrs[k]);
          });
        }
        document.head.appendChild(s);
      }
      if (window.vaupetConsent.isAllowed(category)) {
        inject();
      } else {
        document.addEventListener("vaupet:consent", function onC(e) {
          if (e.detail && e.detail[category]) {
            document.removeEventListener("vaupet:consent", onC);
            inject();
          }
        });
      }
    },
  };

  document.addEventListener("DOMContentLoaded", function () {
    var banner = document.getElementById("cookieBanner");
    if (!banner) return;
    var settings = document.getElementById("cookieSettings");
    var configureBtn = document.getElementById("cookieConfigure");
    var acceptBtn = document.getElementById("cookieAccept");
    var rejectBtn = document.getElementById("cookieReject");
    var saveBtn = document.getElementById("cookieSavePrefs");
    var analyticsToggle = document.getElementById("cookieAnalyticsToggle");
    var marketingToggle = document.getElementById("cookieMarketingToggle");
    var footerBtn = document.getElementById("footerCookieSettings");

    function openBanner(showSettings) {
      var existing = readConsent();
      if (analyticsToggle) analyticsToggle.checked = !!(existing && existing.analytics);
      if (marketingToggle) marketingToggle.checked = !!(existing && existing.marketing);
      banner.classList.add("open");
      if (showSettings) {
        settings.hidden = false;
        configureBtn.setAttribute("aria-expanded", "true");
      }
    }
    function closeBanner() {
      banner.classList.remove("open");
    }

    if (!readConsent()) {
      openBanner(false);
    }

    if (configureBtn) {
      configureBtn.addEventListener("click", function () {
        var isHidden = settings.hidden;
        settings.hidden = !isHidden;
        configureBtn.setAttribute("aria-expanded", String(isHidden));
      });
    }
    if (acceptBtn) {
      acceptBtn.addEventListener("click", function () {
        writeConsent({ necessary: true, analytics: true, marketing: true, ts: Date.now() });
        closeBanner();
      });
    }
    if (rejectBtn) {
      rejectBtn.addEventListener("click", function () {
        writeConsent({ necessary: true, analytics: false, marketing: false, ts: Date.now() });
        closeBanner();
      });
    }
    if (saveBtn) {
      saveBtn.addEventListener("click", function () {
        writeConsent({
          necessary: true,
          analytics: !!(analyticsToggle && analyticsToggle.checked),
          marketing: !!(marketingToggle && marketingToggle.checked),
          ts: Date.now(),
        });
        closeBanner();
      });
    }
    if (footerBtn) {
      footerBtn.addEventListener("click", function () {
        openBanner(true);
      });
    }
  });
})();

document.addEventListener("DOMContentLoaded", function () {
  // Paw print cursor trail (desktop only, throttled)
  var isFinePointerTop = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  var lastPaw = 0;
  if (isFinePointerTop) {
    document.addEventListener("mousemove", function (e) {
      var now = Date.now();
      if (now - lastPaw < 220) return;
      lastPaw = now;
      var paw = document.createElement("div");
      paw.className = "paw-trail";
      paw.style.left = e.clientX - 8 + "px";
      paw.style.top = e.clientY - 8 + "px";
      paw.style.setProperty("--rot", Math.random() * 40 - 20 + "deg");
      paw.innerHTML =
        '<svg viewBox="0 0 100 100" width="16" height="16"><circle cx="50" cy="62" r="22" fill="currentColor"/><circle cx="26" cy="34" r="11" fill="currentColor"/><circle cx="50" cy="22" r="11" fill="currentColor"/><circle cx="74" cy="34" r="11" fill="currentColor"/></svg>';
      paw.style.animation = "paw-fade .9s ease forwards";
      document.body.appendChild(paw);
      setTimeout(function () {
        paw.remove();
      }, 950);
    });
  }

  // AJAX add-to-cart with success animation (no full page reload)
  var cartCountEl = document.querySelector(".cart-count");
  var cartBtnIcon = document.querySelector(".cart-btn");
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('button[type="submit"]');
      if (!submitBtn || submitBtn.classList.contains("is-loading")) return;
      submitBtn.classList.add("is-loading");
      var originalHTML = submitBtn.innerHTML;
      var formData = new FormData(form);

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: { Accept: "application/json" },
      })
        .then(function (res) {
          if (!res.ok) throw new Error("add failed");
          return res.json();
        })
        .then(function () {
          submitBtn.innerHTML =
            '<span class="btn-label">Añadido</span><span class="btn-check">✓ ¡Añadido!</span>';
          submitBtn.classList.add("is-added");
          if (cartBtnIcon) {
            cartBtnIcon.classList.remove("bump");
            void cartBtnIcon.offsetWidth;
            cartBtnIcon.classList.add("bump");
          }
          return fetch("/cart.js").then(function (r) {
            return r.json();
          });
        })
        .then(function (cart) {
          if (cartCountEl) {
            cartCountEl.textContent = cart.item_count;
          } else if (cartBtnIcon && cart.item_count > 0) {
            var span = document.createElement("span");
            span.className = "cart-count";
            span.textContent = cart.item_count;
            cartBtnIcon.appendChild(span);
            cartCountEl = span;
          }
          setTimeout(function () {
            submitBtn.classList.remove("is-added", "is-loading");
            submitBtn.innerHTML = originalHTML;
          }, 1800);
        })
        .catch(function () {
          submitBtn.classList.remove("is-loading");
          submitBtn.innerHTML = originalHTML;
          form.submit();
        });
    });
  });

  // Category flip-card markup wrapper (adds the 3D flip structure without editing every template)
  document.querySelectorAll(".cat-card").forEach(function (card) {
    if (card.querySelector(".cat-card-inner")) return;
    var inner = document.createElement("div");
    inner.className = "cat-card-inner";
    var face = document.createElement("div");
    face.className = "cat-face";
    while (card.firstChild) face.appendChild(card.firstChild);
    var back = document.createElement("div");
    back.className = "cat-back";
    back.textContent = "Ver productos →";
    inner.appendChild(face);
    inner.appendChild(back);
    card.appendChild(inner);
  });

  // Loading screen: hide once everything is ready (only shows briefly per visit)
  var loader = document.getElementById("pageLoader");
  if (loader) {
    var hideLoader = function () {
      loader.classList.add("hidden");
    };
    if (document.readyState === "complete") {
      setTimeout(hideLoader, 250);
    } else {
      window.addEventListener("load", function () {
        setTimeout(hideLoader, 250);
      });
    }
    setTimeout(hideLoader, 1800);
  }

  // Product image zoom (hover-zoom on desktop) + click-to-lightbox (all devices)
  var zoomWrap = document.getElementById("zoomImageWrap");
  var mainImage = document.getElementById("mainProductImage");
  var lightbox = document.getElementById("lightbox");
  var lightboxImage = document.getElementById("lightboxImage");
  var lightboxClose = document.getElementById("lightboxClose");

  // Variant selector: swap main image and price when choosing color/size
  var variantSelect = document.getElementById("productVariantSelect");
  var priceDisplay = document.getElementById("productPriceDisplay");
  var thumbEls = document.querySelectorAll(".product-thumb");

  if (variantSelect && mainImage) {
    variantSelect.addEventListener("change", function () {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      var newPrice = opt.getAttribute("data-price");
      var newImage = opt.getAttribute("data-image");
      var newZoom = opt.getAttribute("data-zoom");
      var idx = parseInt(opt.getAttribute("data-index"), 10) || 0;

      if (priceDisplay && newPrice) {
        priceDisplay.textContent = newPrice;
      }

      if (newImage) {
        // This variant has its own dedicated photo in Shopify
        mainImage.src = newImage;
        mainImage.setAttribute("data-zoom", newZoom || newImage);
      } else if (thumbEls.length > 0) {
        // No dedicated photo: rotate through the product's existing gallery images
        var thumb = thumbEls[idx % thumbEls.length];
        var fallbackFull = thumb.getAttribute("data-full");
        var fallbackZoom = thumb.getAttribute("data-zoom");
        if (fallbackFull) {
          mainImage.src = fallbackFull;
          mainImage.setAttribute("data-zoom", fallbackZoom || fallbackFull);
        }
      }
    });
  }


  function openLightbox(src, alt) {
    if (!lightbox) return;
    lightboxImage.src = src;
    lightboxImage.alt = alt || "";
    lightbox.classList.add("open");
    document.body.style.overflow = "hidden";
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove("open");
    document.body.style.overflow = "";
  }

  if (zoomWrap && mainImage) {
    zoomWrap.addEventListener("mousemove", function (e) {
      if (!isFinePointerTop) return;
      var rect = zoomWrap.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      mainImage.style.transformOrigin = x + "% " + y + "%";
      zoomWrap.classList.add("zooming");
    });
    zoomWrap.addEventListener("mouseleave", function () {
      zoomWrap.classList.remove("zooming");
    });
    zoomWrap.addEventListener("click", function () {
      openLightbox(mainImage.getAttribute("data-zoom") || mainImage.src, mainImage.alt);
    });
  }

  document.querySelectorAll(".product-thumb").forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      var full = thumb.getAttribute("data-full");
      var zoom = thumb.getAttribute("data-zoom");
      if (mainImage && full) {
        mainImage.src = full;
        mainImage.setAttribute("data-zoom", zoom);
      } else if (zoom) {
        openLightbox(zoom, "");
      }
    });
  });

  if (lightboxClose) lightboxClose.addEventListener("click", closeLightbox);
  if (lightbox) {
    lightbox.addEventListener("click", function (e) {
      if (e.target === lightbox) closeLightbox();
    });
  }
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeLightbox();
  });

  // Search overlay dropdown
  var searchToggle = document.getElementById("searchToggle");
  var searchOverlay = document.getElementById("searchOverlay");
  var searchOverlayInput = document.getElementById("searchOverlayInput");
  var searchOverlayClose = document.getElementById("searchOverlayClose");
  function openSearch() {
    searchOverlay.classList.add("open");
    searchOverlay.removeAttribute("inert");
    searchToggle.setAttribute("aria-expanded", "true");
    setTimeout(function () {
      searchOverlayInput.focus();
    }, 150);
  }
  function closeSearch() {
    searchOverlay.classList.remove("open");
    searchOverlay.setAttribute("inert", "");
    searchToggle.setAttribute("aria-expanded", "false");
  }
  if (searchOverlay) searchOverlay.setAttribute("inert", "");
  if (searchToggle) {
    searchToggle.addEventListener("click", function () {
      if (searchOverlay.classList.contains("open")) closeSearch();
      else openSearch();
    });
  }
  if (searchOverlayClose) searchOverlayClose.addEventListener("click", closeSearch);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeSearch();
  });

  // Mobile nav (hamburger drawer)
  var menuToggle = document.getElementById("menuToggle");
  var mobileNav = document.getElementById("mobileNav");
  var mobileNavBackdrop = document.getElementById("mobileNavBackdrop");
  var mobileNavClose = document.getElementById("mobileNavClose");
  function openMobileNav() {
    mobileNav.classList.add("open");
    mobileNav.removeAttribute("inert");
    mobileNavBackdrop.classList.add("open");
    menuToggle.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
    setTimeout(function () {
      if (mobileNavClose) mobileNavClose.focus();
    }, 150);
  }
  function closeMobileNav() {
    mobileNav.classList.remove("open");
    mobileNav.setAttribute("inert", "");
    mobileNavBackdrop.classList.remove("open");
    menuToggle.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
  }
  if (mobileNav) mobileNav.setAttribute("inert", "");
  if (menuToggle) {
    menuToggle.addEventListener("click", function () {
      if (mobileNav.classList.contains("open")) closeMobileNav();
      else openMobileNav();
    });
  }
  if (mobileNavClose) mobileNavClose.addEventListener("click", closeMobileNav);
  if (mobileNavBackdrop) mobileNavBackdrop.addEventListener("click", closeMobileNav);
  if (mobileNav) {
    mobileNav.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", closeMobileNav);
    });
  }
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeMobileNav();
  });

  // Back to top button
  var backToTop = document.getElementById("backToTop");
  if (backToTop) {
    window.addEventListener("scroll", function () {
      if (window.scrollY > 500) backToTop.classList.add("visible");
      else backToTop.classList.remove("visible");
    }, { passive: true });
    backToTop.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  // Smooth page transition: fade out before leaving to another page on this site
  document.addEventListener("click", function (e) {
    var link = e.target.closest("a");
    if (!link) return;
    var href = link.getAttribute("href");
    if (!href || href.charAt(0) === "#") return;
    if (link.target === "_blank" || link.hasAttribute("download")) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    var url;
    try { url = new URL(href, window.location.href); } catch (err) { return; }
    if (url.origin !== window.location.origin) return;
    if (url.pathname === window.location.pathname) return;
    e.preventDefault();
    document.body.classList.add("page-exit");
    setTimeout(function () {
      window.location.href = url.href;
    }, 200);
  });

  // Fix: when the browser restores a page from cache (e.g. clicking the
  // browser's Back button), make sure it isn't stuck invisible from the
  // fade-out effect above.
  window.addEventListener("pageshow", function () {
    document.body.classList.remove("page-exit");
  });

  // "Back" link, inline at the top of the page content — not floating,
  // so it can never overlap the header/logo on any screen size.
  if (window.history.length > 1 && window.location.pathname !== "/") {
    var mainEl = document.querySelector("main");
    if (mainEl) {
      var backWrap = document.createElement("div");
      backWrap.className = "site-back-wrap";
      backWrap.innerHTML =
        '<button type="button" class="site-back-btn" aria-label="Volver atrás">' +
        '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg>' +
        '<span>Volver</span>' +
        "</button>";
      mainEl.insertBefore(backWrap, mainEl.firstChild);
      backWrap.querySelector(".site-back-btn").addEventListener("click", function () {
        document.body.classList.remove("page-exit");
        window.history.back();
      });
    }
  }

  // Scroll progress bar
  var progress = document.createElement("div");
  progress.className = "scroll-progress";
  document.body.appendChild(progress);
  function updateProgress() {
    var h = document.documentElement;
    var scrolled = (h.scrollTop) / (h.scrollHeight - h.clientHeight) * 100;
    progress.style.width = (scrolled || 0) + "%";
  }
  window.addEventListener("scroll", updateProgress, { passive: true });

  // Sticky header shadow on scroll
  var header = document.getElementById("siteHeader");
  window.addEventListener("scroll", function () {
    if (header) {
      if (window.scrollY > 12) header.classList.add("scrolled");
      else header.classList.remove("scrolled");
    }
  }, { passive: true });

  // Word-by-word text reveal: splits big headlines into per-word spans so
  // they rise into place staggered, instead of appearing as one flat block.
  // Element nodes inside the text (e.g. the highlighted "<span>perro</span>")
  // are treated as a single word so they keep their own styling/underline.
  function splitIntoWords(el) {
    if (!el || el.dataset.wordsSplit) return;
    el.dataset.wordsSplit = "1";
    var nodes = Array.prototype.slice.call(el.childNodes);
    el.textContent = "";
    var wordIndex = 0;
    function wrapWord(content) {
      var outer = document.createElement("span");
      outer.className = "split-word";
      var inner = document.createElement("span");
      inner.className = "split-word-inner";
      inner.style.animationDelay = wordIndex * 0.045 + "s";
      inner.appendChild(content);
      outer.appendChild(inner);
      el.appendChild(outer);
      wordIndex++;
    }
    nodes.forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE) {
        var parts = node.textContent.split(/(\s+)/);
        parts.forEach(function (part) {
          if (part === "") return;
          if (/^\s+$/.test(part)) {
            el.appendChild(document.createTextNode(part));
          } else {
            wrapWord(document.createTextNode(part));
          }
        });
      } else {
        wrapWord(node);
      }
    });
  }
  document
    .querySelectorAll(".hero h1, .about-text h2, .cta-banner h2, .newsletter h2")
    .forEach(splitIntoWords);

  // Reveal on scroll
  var revealEls = document.querySelectorAll(".reveal, .reveal-stagger");
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    revealEls.forEach(function (el) {
      io.observe(el);
    });
  } else {
    revealEls.forEach(function (el) {
      el.classList.add("in");
    });
  }

  // Parallax on scroll: background blobs drift for a subtle depth effect.
  // (The hero product image itself no longer moves on scroll — it stays
  // centered and never overlaps the content below.)
  var heroSection = document.querySelector(".hero");
  var blobs = document.querySelectorAll(".hero-blob");
  function updateParallax() {
    if (!heroSection) return;
    var rect = heroSection.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > window.innerHeight) return;
    blobs.forEach(function (blob, i) {
      var speed = (i + 1) * 0.18;
      blob.style.transform = "translateY(" + (-rect.top * speed) + "px)";
    });
  }
  window.addEventListener("scroll", updateParallax, { passive: true });
  updateParallax();

  // Section nav dots — highlight the one matching the section currently in view
  var dotLinks = document.querySelectorAll(".section-dots a");
  if (dotLinks.length) {
    var dotTargets = Array.prototype.map.call(dotLinks, function (a) {
      return document.querySelector(a.getAttribute("href"));
    });
    var dotIo = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var idx = dotTargets.indexOf(entry.target);
          if (idx === -1) return;
          if (entry.isIntersecting) {
            dotLinks.forEach(function (a) { a.classList.remove("active"); });
            dotLinks[idx].classList.add("active");
          }
        });
      },
      { threshold: 0.5 }
    );
    dotTargets.forEach(function (el) {
      if (el) dotIo.observe(el);
    });
  }

  // Animated stat counters, triggered on scroll into view
  var statNumbers = document.querySelectorAll(".stat-number");
  if (statNumbers.length && "IntersectionObserver" in window) {
    var statIo = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCount(entry.target);
            statIo.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );
    statNumbers.forEach(function (el) {
      statIo.observe(el);
    });
  }
  function animateCount(el) {
    var target = parseInt(el.getAttribute("data-target"), 10) || 0;
    var duration = 1400;
    var start = performance.now();
    function tick(now) {
      var progress = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.round(eased * target);
      if (progress < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  // Newsletter form (demo submit, no backend action needed beyond Shopify's own)
  var form = document.querySelector(".newsletter-form");
  if (form) {
    form.addEventListener("submit", function () {
      var btn = form.querySelector(".btn");
      if (btn) btn.textContent = "¡Gracias!";
    });
  }

  var isFinePointer = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  if (!isFinePointer) return;

  // Cursor glow that follows the pointer
  var glow = document.createElement("div");
  glow.className = "cursor-glow";
  document.body.appendChild(glow);
  window.addEventListener("mousemove", function (e) {
    glow.style.left = e.clientX + "px";
    glow.style.top = e.clientY + "px";
    glow.classList.add("active");
  });
  window.addEventListener("mouseleave", function () {
    glow.classList.remove("active");
  });

  // Hero parallax: mouse position drives a radial highlight + blob drift
  var hero = document.querySelector(".hero");
  if (hero) {
    var blobs = hero.querySelectorAll(".hero-blob");
    hero.addEventListener("mousemove", function (e) {
      var rect = hero.getBoundingClientRect();
      var px = ((e.clientX - rect.left) / rect.width) * 100;
      var py = ((e.clientY - rect.top) / rect.height) * 100;
      hero.style.setProperty("--mx", px + "%");
      hero.style.setProperty("--my", py + "%");
      var dx = (e.clientX - rect.left - rect.width / 2) / rect.width;
      var dy = (e.clientY - rect.top - rect.height / 2) / rect.height;
      blobs.forEach(function (blob, i) {
        var strength = (i + 1) * 14;
        blob.style.transform =
          "translate(" + dx * strength + "px," + dy * strength + "px)";
      });
    });
  }

  // 3D tilt for cards and hero image
  function addTilt(el, maxTilt) {
    var rect;
    el.addEventListener("mouseenter", function () {
      rect = el.getBoundingClientRect();
    });
    el.addEventListener("mousemove", function (e) {
      if (!rect) rect = el.getBoundingClientRect();
      var px = (e.clientX - rect.left) / rect.width - 0.5;
      var py = (e.clientY - rect.top) / rect.height - 0.5;
      var rotY = px * maxTilt;
      var rotX = -py * maxTilt;
      el.style.transform =
        "perspective(900px) rotateX(" + rotX + "deg) rotateY(" + rotY + "deg) scale(1.03)";
    });
    el.addEventListener("mouseleave", function () {
      el.style.transform = "perspective(900px) rotateX(0) rotateY(0) scale(1)";
    });
  }
  document.querySelectorAll(".product-card, .cat-card").forEach(function (el) {
    addTilt(el, 10);
  });
  var heroImg = document.querySelector(".hero-image-wrap");
  if (heroImg) addTilt(heroImg, 6);

  // Magnetic buttons
  document.querySelectorAll(".btn").forEach(function (btn) {
    var rect;
    btn.addEventListener("mouseenter", function () {
      rect = btn.getBoundingClientRect();
    });
    btn.addEventListener("mousemove", function (e) {
      if (!rect) rect = btn.getBoundingClientRect();
      var mx = e.clientX - rect.left - rect.width / 2;
      var my = e.clientY - rect.top - rect.height / 2;
      btn.style.transform = "translate(" + mx * 0.25 + "px," + my * 0.4 + "px)";
    });
    btn.addEventListener("mouseleave", function () {
      btn.style.transform = "translate(0,0)";
    });
  });
});
